import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'smartCurrency',
})
export class SmartCurrencyPipe implements PipeTransform {
  transform(
    value: number,
    currencyCode: string = 'PEN',
    digits: string = '1.2-2',
  ): string {
    const locale = currencyCode === 'USD' ? 'en-US' : 'es-PE';

    const [minMaxStr, maxStr] = digits.split('-');
    const [, minStr] = minMaxStr.split('.');

    const minFrac = parseInt(minStr || '2', 10);
    const maxFrac = parseInt(maxStr || '2', 10);

    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: minFrac,
      maximumFractionDigits: maxFrac,
    }).format(value);
  }
}
